export default __webpack_public_path__ + "static/media/No.6-3.4fd22208.jpg";